import { snapshot } from 'valtio'
import { customerProxy } from '../../../../shared/proxies/customerProxy'
import { buildAxiosInstance } from '../../../../shared/utils/apiUtils'
import { type GlobalCustomerCardType } from '../../../../shared/types/GlobalCustomerCardType'

interface Response {
  data: {
    customerCard: GlobalCustomerCardType
  } | null
  error: string | null
}
export async function apiExecuteCustomerDetailsCardDelete (id: string): Promise<string | undefined> {
  customerProxy.apiCallCustomerCardDelete.loading = true
  customerProxy.apiCallCustomerCardDelete.error = null
  const { customer } = snapshot(customerProxy)
  try {
    const axiosInstance = buildAxiosInstance()
    const response = await axiosInstance.post<Response>('/api/customer_cards/delete', {
      customerCardId: id,
      customerId: customer?.id
    })
    if (response.data.data) {
      return response.data.data.customerCard.id
    } else {
      customerProxy.apiCallCustomerCardDelete.error = response.data.error
    }
  } catch (e) {
    if (e instanceof Error) {
      customerProxy.apiCallCustomerCardDelete.error = e.message
    }
  } finally {
    customerProxy.apiCallCustomerCardDelete.loading = false
  }
}
